<template>
    <div class="toast" name="fade" v-if="toaster.isVisible && toaster.type">
      <div v-if="toaster.type === 'error'" style="width: 350px; position: absolute; top:40px; right:calc((100vw - 500px)/2)" 
        class="toaster-container bg-red rounded-full text-white px-6 py-3 rounded relative" role="alert">
        <strong class="font-semibold">Failure</strong>
        <br>
        <span v-if="toaster.message !== null" class="block sm:inline">{{toaster.message}}</span>
        <span v-else class="block sm:inline">Request failed</span>
      </div>
      <div v-if="toaster.type === 'success'" style="width: 350px; position: absolute; top:40px; right:calc((100vw - 500px)/2)" 
        class="toaster-container bg-green rounded-full text-white px-6 py-3 rounded relative" role="alert">
        <strong class="font-semibold">Success</strong>
        <br>
        <span class="block sm:inline">Request successful</span>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      toaster: 'toaster/toasterState'
    })
  },
  methods: {
    ...mapActions({
      setToaster: 'toaster/setToaster'
    })
  }
}
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/components/common/Toaster.vue